export const videos = () => {
  return {
    en: "https://www.youtube.com/embed/R69LWRzUGUY",
    fr: "https://www.youtube.com/embed/vtYUktkOggs",
    pt: "https://www.youtube.com/embed/R69LWRzUGUY",
    sw: "https://www.youtube.com/embed/R69LWRzUGUY",
  };
};
